import React from "react";

const HealthCheckPage: React.FC = () => {
  const containerStyle: React.CSSProperties = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f0f2f5",
  };

  const messageStyle: React.CSSProperties = {
    fontSize: "30px",
    fontWeight: "bold",
    color: "#333",
  };

  return (
    <div style={containerStyle}>
      <h1 style={messageStyle}>This is DataTram's Health Check</h1>
    </div>
  );
};

export default HealthCheckPage;
